import { AccountInterestMyPageTopicsData, AccountsInterestData } from "@/Interfaces/I_AccountsInterest";
import { PaginationData } from "@/Interfaces/I_modal";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const accountsInterestSlice = createSlice({
  name: 'accountsInterestSlice',
  initialState: {
    accountsInterest: {
        data: [] as AccountsInterestData[],
        pagination: {} as PaginationData,
      },
    topics: [] as AccountInterestMyPageTopicsData[],    
    loading: false,
    loadingStreamerData: false,
    error: '',
  },
  reducers: {
    getAccountsInterest: (state, action) => {
      const assignState = state;
      assignState.loading = true;
    },
    setAccountsInterest: (state, action) => {
      const assignState = state;
      assignState.accountsInterest.data =  action.payload.accountInterest;
      assignState.accountsInterest.pagination = action.payload.pagination;
      assignState.loading = false;
    },
    setUpdatedAccountInterest: (state, action) => {
      const assignState = state;
      assignState.accountsInterest.data =  assignState.accountsInterest.data.map(item =>
        item.id === action.payload.id ? action.payload : item
      );
      assignState.loading = false;
    },
    updateAccountsInterest: (state, action) => {
      const assignState = state;
      assignState.loading = true;
    },
    getAccountInterestMyPageTopics: (state) => {
      const assignState = state;
      assignState.loading = true;
    },
    setAccountInterestMyPageTopics: (state, action) => {
      const assignState = state;
      assignState.topics = action.payload;
      assignState.loading = false;
    },
  }
})

export const {
  getAccountsInterest,
  setAccountsInterest,
  updateAccountsInterest,
  getAccountInterestMyPageTopics,
  setAccountInterestMyPageTopics,
  setUpdatedAccountInterest,
} = accountsInterestSlice.actions;

export default accountsInterestSlice.reducer;
